import React, { useState, useRef, useContext } from 'react';
import { M as MenuItem } from './MenuItem-tjmskPE4.js';
import { S as SubMenu } from './SubMenu-csdsWesR.js';
import { L as Logo } from './Logo-fy1HhiD6.js';
import { CoreContext } from './context/index.js';
import './utils/logToSlack.js';
import './animations--PMkOS0j.js';
import 'cookies-next';
import './currency-_kacFJHO.js';
import './language-BHHwgtQp.js';
import './payment-YC9H491Y.js';
import useAutoFocus from './hooks/useAutoFocus.js';
import './index-xPaCrlMu.js';
import { useRouter } from 'next/router';
import 'notistack';
import 'next-i18next';
import 'lodash/get';
import './product-_pRduMz7.js';
import './helpers-kA_hdoOI.js';
import 'lodash';
import { c as classnames } from './index-2586sEvh.js';
import Link from './components/Link/index.js';
import { useTranslation } from 'react-i18next';

const MenuMobile = ({ items, setShowMobileMenu }) => {
    const [showSubMenuData, setShowSubMenuData] = useState(null);
    const { locale } = useRouter();
    const { t: tLabel } = useTranslation('', { keyPrefix: '$common.$labels' });
    const ref = useAutoFocus({ tag: 'button' });
    const logoRef = useRef();
    const { data: { siteConfig: { LOGO_IMAGE, header: { mobileNavLogo = false, mobileNavHome = false } = {} }, }, } = useContext(CoreContext);
    const homeLink = (React.createElement("li", null,
        React.createElement(Link, { href: `/${locale}`, className: "link", noClass: true, onClick: () => setShowMobileMenu(false) }, tLabel('homepage'))));
    return (React.createElement("div", { className: classnames('navigation-menu-mobile', { 'has-logo': mobileNavLogo }) },
        mobileNavLogo && LOGO_IMAGE && (React.createElement(Logo, { url: `/${locale}`, img: LOGO_IMAGE, ref: logoRef, onClick: () => setShowMobileMenu(false) })),
        !showSubMenuData && (React.createElement("ul", { ref: ref, className: "main-menu" },
            mobileNavHome && homeLink,
            items.map(item => (React.createElement(MenuItem, { key: item.item_id, item: item, onSelect: setShowSubMenuData, setShowMobileMenu: setShowMobileMenu }))))),
        showSubMenuData && (React.createElement(SubMenu, { item: showSubMenuData, onBack: () => setShowSubMenuData(null), setShowMobileMenu: setShowMobileMenu }))));
};

export { MenuMobile as M };
//# sourceMappingURL=MenuMobile-rQkeExKP.js.map
